<script lang="ts" module>
  import type { ButtonProps } from "../button/Button.svelte"

  export type DialogCloseProps = ButtonProps
</script>

<script lang="ts">
  import { cn } from "#lib/utils"
  import { Close } from "@tastyworks/icons"
  import Button from "../button/Button.svelte"
  import { getDialogRootContext } from "./DialogRoot.svelte"

  const rootCtx = getDialogRootContext()

  let {
    class: cssClass = "",
    variant = "ghost",
    size = "medium",
    onclick,
    use = [],
    children,
    ...restProps
  }: DialogCloseProps = $props()

  // [Claude] Attaches the click handler directly via addEventListener rather than passing
  // onclick through props. Event handlers spread onto <svelte:element> in Button
  // don't fire reliably with programmatic clicks (e.g. Playwright e2e tests).
  function closeAction(node: HTMLElement) {
    function handleClick(e: MouseEvent) {
      $rootCtx = { ...$rootCtx, open: false }
      ;(onclick as ((e: MouseEvent) => void) | undefined)?.(e)
    }
    node.addEventListener("click", handleClick)
    return {
      destroy() {
        node.removeEventListener("click", handleClick)
      },
    }
  }
</script>

<Button
  class={cn(
    "flex items-center justify-center p-0 focus-visible:outline-none focus-visible:ring-2",
    cssClass
  )}
  {variant}
  {size}
  aria-label="Close"
  use={[closeAction, ...use]}
  {...restProps}
>
  {#if children}
    {@render children()}
  {:else}
    <Close class="h-6 w-6" />
  {/if}
</Button>
